import React from "react";
import "./CardTemplateStyle.css";
const CardTemplate = ({
  tituloCard,
  iconTituloCard,
  tituloBodyCard,
  onClickVerPerfil,
  classTituloBody,
  bodyCard,
  rotated,
  classTemplateBox,
  classTittleBox,
  imgTittle,
}) => {
  return (
    <React.Fragment>
      <div className={`ptur-card-template ${classTemplateBox}`}>
        {iconTituloCard ? (
          <div className={`ptur-card-template-titleBox ${classTittleBox} rb18m `}>
            {tituloCard && (        
              <h2 className="ptur-card-template-titleBtn rb18m">
                {imgTittle && <div className="ptur-card-template-titleBtn-img">{imgTittle}</div>}
                {tituloCard}
              </h2>
            )}
            {/* Si en algun momento vuelve el boton VER. dejo comentada las lineas.
            <div className="ptur-card-template-btn">
              <button onClick={onClickVerPerfil}className="rb16m">
                Ver
                <img
                  className={rotated ? "img-rotatedX180 ptur-card-template-btnFlecha" : "ptur-card-template-btnFlecha"}
                  src={flechaVerPerfil}
                  alt="dropPerfil"
                ></img>
              </button>
            </div> */}
          </div>
        ) : (
          <div className="ptur-card-template-header">
            {tituloCard && (
              <h2 className="ptur-card-template-title rb18m">{tituloCard}</h2>
            )}
          </div>
        )}

        <div className={`ptur-card-template-body`}>
          {tituloBodyCard && (
            <h2
              className={`ptur-body-template-title ${classTituloBody} rb18l`}
            >
              {tituloBodyCard}
            </h2>
          )}
          {bodyCard}
        </div>
      </div>
    </React.Fragment>
  );
};
export default CardTemplate;
